'use client';


function GA4PixelInternal() {
  return (
    <>
      <script
        id="google-tag-analytics-script"
        type="text/partytown"
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-V2WCQ5LPWW"
      />
      <script
        id="google-tag-analytics-loader"
        type="text/partytown"
        dangerouslySetInnerHTML={{
          __html: `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-V2WCQ5LPWW');`,
        }}
      />
    </>
  );
}

export function GA4Pixel() {
  return <GA4PixelInternal />;
}
